import { createContext, Dispatch, FC, PropsWithChildren, SetStateAction, useEffect, useState } from 'react';
import { configureRootTheme } from "@yandex-int/hr-components/Theme";
import { ThemeProvider as HrTechThemeProvider } from '@yandex-int/hr-components/hooks/useSystemTheme/context';
import { theme as lightTheme } from "@yandex-int/hr-components/Theme/presets/light";
import { theme as darkTheme } from "@yandex-int/hr-components/Theme/presets/dark";

export type ThemeType = 'light' | 'dark';

export const themeContext = createContext<[ThemeType, Dispatch<SetStateAction<ThemeType>>]>(['light', () => {
}]);

interface IThemeProviderProps extends PropsWithChildren {
}

export const ThemeProvider: FC<IThemeProviderProps> = ({ children }) => {
    const [theme, setTheme] = useState<ThemeType>('light');

    useEffect(() => {
        const lastTheme = localStorage.getItem('hrComponentsTheme');
        if (lastTheme && ['light', 'dark'].includes(lastTheme)) {
            setTheme(lastTheme as ThemeType);
        }
    }, []);

    useEffect(() => {
        configureRootTheme({ theme: theme === 'light' ? lightTheme : darkTheme })
    }, [theme]);


    return <themeContext.Provider value={[theme, setTheme]}>
        <HrTechThemeProvider>
            {children}
        </HrTechThemeProvider>
    </themeContext.Provider>;
}
